<p>
    By default this is the highest average of your pensionable annual earnings
    plus any applicable pensionable AIP over 36 or 60 consecutive months, as
    applicable, as of your last annual pension statement. <br /><br />
    If you had a recent salary increase and would like this increase reflected in
    the pension projections shown, you can override your last annual pension
    statement average.
  </p>
  